module.exports = __webpack_public_path__ + "static/media/augendusche_btn_falsch.c820ded6.jpg";